import { DocumentTypes } from '@/types/document';

// Mirrors PERIOD_CLOSED_REASON_* and the Merit blocked reasons in companio_api.
export enum DocumentDeletionBlockedReason {
  PAST_PERIOD = 'past_period',
  DECLARATION_SUBMITTED = 'declaration_submitted',
  PAID = 'paid',
  RECONCILED = 'reconciled',
  LOCKED = 'locked',
  UNKNOWN = 'unknown'
}

export type DocumentDeletionBlockedDetail = {
  errorCode?: string;
  reason?: DocumentDeletionBlockedReason | string | null;
  documentType?: DocumentTypes | string | null;
  retryable?: boolean;
  message?: string;
};
